import * as React from "react";
import { Pagination, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, Edit, SimpleForm, useDataProvider } from 'react-admin';
import { fetcherGetSync } from "../utils/fetcher";
import {downloadFile} from "../utils/utils"
//var fetcher = require ("../utils/fetcher");
import config from "../config";

const redirect = (basepath, id, data) => { 
    var res = fetcherGetSync(config.API_HOST+"/address/"+id+"/getuserinfos");

    return "/users/"+res.type;
} ;
// https://stackoverflow.com/questions/50340149/react-admin-how-to-redirect-to-a-specified-list-after-hitting-save-on-a-cus


const exportAddresses = () => {
    downloadFile(config.API_HOST+"/exports/individuals", "individuals.csv");
}


export const AddressList = props => (
    <List exporter={exportAddresses} {...props}>
        <Datagrid rowClick="edit" pagination={<Pagination rowsPerPageOptions={[6, 12, 24, 36]} />} >
            <TextField source="id" />
            <TextField source="adress1" />
            <TextField source="adress2" />
            <TextField source="adress3" />
            <TextField source="postalCode" />
            <TextField source="city" />
            <TextField source="wording" />
        </Datagrid>
    </List>
);

export const AddressEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect={redirect}>
            <TextInput disabled source="id" />
            <TextInput disabled source="clientId" />
            <TextInput source="adress1" />
            <TextInput source="adress2" />
            <TextInput source="adress3" />
            <TextInput source="postalCode" />
            <TextInput source="city" />
            <TextInput source="wording" />
        </SimpleForm>
    </Edit>
);